import React from 'react';

function LinkBroken(props) {
	return (
		<svg height="20" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<g fill="#000" strokeLinecap="butt" strokeLinejoin="miter">
		<path d="M14.56 2.06l-0.42 0.72" fill="none" stroke="#000" strokeLinecap="square" strokeWidth="2"/>
		<path d="M5.82 17.19l-0.41 0.72" fill="none" stroke="#000" strokeLinecap="square" strokeWidth="2"/>
		<path d="M17.91 5.41l-0.72 0.41" fill="none" stroke="#000" strokeLinecap="square" strokeWidth="2"/>
		<path d="M2.78 14.14l-0.72 0.42" fill="none" stroke="#000" strokeLinecap="square" strokeWidth="2"/>
		<path d="M3.98 9.28l-0.47-0.47a3.74 3.74 0 1 1 5.3-5.3l2.94 2.95a3.74 3.74 0 0 1-0.36 5.6" fill="none" stroke="#000" strokeLinecap="square" strokeWidth="2"/>
		<path d="M8.53 7.94a3.74 3.74 0 0 0-0.31 5.57l2.94 2.95a3.74 3.74 0 1 0 5.3-5.3l-0.48-0.46" fill="none" stroke="#000" strokeLinecap="square" strokeWidth="2"/>
	</g>
</svg>
	);
};

export default LinkBroken;